import { renderBlockMCQ } from "../MCQ";

const renderBlockReOrder = (block: any) => renderBlockMCQ(block, false);

export default renderBlockReOrder;
